<template>
  <modal-template>
    <template #header>
      <div>
        <div class="modal-header-style">
          <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
            <span>add account</span>
          </div>
          <div style="float:right;">
            <label class="action-icon-style" v-on:click="$emit('close', true)">
              <font-awesome-icon icon="xmark" size="xl"/>
              <span style="display: block;">close</span>
            </label>
          </div>
        </div>
      </div>
      <div style="width:100%;float:left;color:black;">
        <div style="float:left;">
          <span style="font-size:larger;font-weight:bold;">
            <sup>[{{ dairy.id }}]</sup> {{ dairy.name }}
          </span>
        </div>
      </div>
    </template>
    <template #body>
      <div class="table-container" style="max-height: 325px;">
        <table>
          <thead>
          <tr>
            <th style="width:90%;">
              <input v-model="searchText"
                     style="width:100%;"
                     autofocus
                     class="login-input"
                     type="search"
                     placeholder="search..."
                     autocomplete="off"/>
            </th>
            <th style="width:10%;text-align:right;">
              <label class="order-icon-style" style="display: block;" v-on:click="search">
                <font-awesome-icon icon="magnifying-glass" size="xl"/>
                <span style="display: block;">search</span>
              </label>
            </th>
          </tr>
          </thead>
          <template v-for="account in results" :key="account">
            <tr>
              <td>
                <div style="text-align:left;font-weight:bold;">
                  <span>
                    <sup>[{{ account.customerId }}]</sup> {{ account.customerName }}
                  </span>
                </div>
                <div class="product-banner">
                  <span>
                    {{ account.deliveryType }} | deck: {{ account.priceDeck }}
                  </span>
                </div>
              </td>
              <td style="text-align:right;">
                <i class="order-icon-style" style="display: block;" v-on:click="add(account)">
                  <font-awesome-icon icon="store" size="xl"/>
                  <span style="display: block;">add</span>
                </i>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </template>
    <template #footer>
    </template>
  </modal-template>

  <maintain-user v-if="displayMaintainUsers"
                 :account="selectedAccount"
                 @close="closeMaintainUsers">
  </maintain-user>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'
import MaintainUser from '@/components/administrator/account/assignment/Maintain'

export default {
  name: 'AddAccount',
  props: ['dairy', 'accountlist'],
  emits: ['accounts', 'close', 'apierror', 'apierrortext'],
  components: {
    ModalTemplate,
    MaintainUser,
  },
  data: function () {
    return {
      searchText: '',
      results: [],
      selectedAccount: {},
      displayMaintainUsers: false,
    }
  },
  methods: {
    search: function () {
      this.results = []

      if (this.searchText.length > 1) {
        this.axios
            .get('admin/accounts', {
              params: {
                dairyId: this.dairy.id,
                dairyName: this.dairy.name,
                searchText: this.searchText
              }
            })
            .then(response => {
              this.results = response.data
              _.pullAllBy(this.results, this.accountlist, 'customerId')
              this.results = _.sortBy(this.results, ['customerName', 'customerId'], ['asc', 'asc'])

              this.searchText = ''
            })
            .catch(error => {
              this.$emit('apierror', true)
              this.$emit('apierrortext', error.response.statusText)
            })
      }
    },
    add: function (selection) {
      this.displayMaintainUsers = false
      this.selectedAccount = selection

      this.accounts.push(selection)
      _.pull(this.results, selection)

      this.$emit('accounts', this.accounts)
      this.displayMaintainUsers = true
    },
    closeMaintainUsers: function () {
      this.displayMaintainUsers = false
    }
  },
  mounted() {
    this.accounts = this.accountlist
  },
}
</script>

<style scoped>
.modal-header-style {
  width: 100%;
  float: left;
  background: black;
  color: white;
  border-radius: 4px;
}

.action-icon-style {
  color: white;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.action-icon-style:hover {
  font-weight: bolder;
}

.order-icon-style {
  color: black;
  text-align: center;
  cursor: pointer;
  width: 80px;
}

.order-icon-style:hover {
  font-weight: bolder;
}

ul li {
  display: inline-block;
}
</style>
